<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <DocumentosUsuarios></DocumentosUsuarios>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import DocumentosUsuarios from '../components/DocumentosUsuarios.vue';
export default {
    name: 'UserDocumentView',
    components: {
        ColumnaIzquierda,
        DocumentosUsuarios,
    }
}
</script>